// Dependencies
import _ from 'lodash'; 
import styled, {css} from 'styled-components';
import { Helpers } from '../../utils';

// Types
import { Components } from "../../types";
 
// Components
import Icon from '../Icon';

export const Availability = ({translations, product, ...props}: Components.ProductAvailability) => {
    
    return (
        <AvailabilityWrapper status={product.stockStatus}>
            <AvailabilityText>
                <Icon id={`stock_${product.stockStatus}`} {...props} />
                <StockStatus>
                    {translations.stock[product.stockStatus]}
                </StockStatus>
            </AvailabilityText>
            { product?.meta?.deliveryTime && <DeliveryTime>{`${product.meta.deliveryTime}`}</DeliveryTime> }
        </AvailabilityWrapper>
    )

}

export const AvailabilityWrapper = styled.div<any>(
({ status, theme: { general, components: {availability: style} } }) => css`
    display: flex;
    flex-direction: column;

    color: ${style.color[status]};
 
    svg {
        margin-right: .5em;
    }
`);

export const AvailabilityText = styled.span<any>(
({ theme: { general, components: {addToCartButton: style} } }) => css`
    display: flex;
    align-items: center;
    color: currentColor;
`);

export const StockStatus = styled.strong<any>(
({ theme: { general, components: {addToCartButton: style} } }) => css`
    color: currentColor;
    text-transform: uppercase;
    font-weight: 600;
    ${Helpers.clamp('font-size', 1, 1.25, 2.5)};
`);

export const DeliveryTime = styled.small<any>(
({ theme: { general, components: {addToCartButton: style} } }) => css`
    color: currentColor;
    ${Helpers.clamp('font-size', 0.75, 1, 2.5)};
`);